const createConfig = (headingOffset) => ({
    breaks: true,
    gfm: true,
    renderer: {
        codespan({text}) {
            return `<code class="kui-util-code-inline kui-util-type-mono-2">${text}</code>`;
        },

        code({text, lang}) {
            const langClass = lang ? `language-${lang}` : '';
            const langLabel = lang
                ? `<p class="kui-util-type-body-caption">${lang}</p>`
                : '';

            return `
                <div class="c-marked-code-block">
                    <pre>${langLabel}<code class="${langClass}">${text}</code></pre>
                </div>
            `;
        },

        heading({tokens, depth}) {
            const classMap = {
                2: 'kui-util-type-headline-3',
                3: 'kui-util-type-headline-4',
                4: 'kui-util-type-headline-5',
                5: 'kui-util-type-subhead-1',
                6: 'kui-util-type-subhead-1'
            };
            const text = this.parser.parseInline(tokens);
            let level = depth + headingOffset;

            // Clamp to valid range
            if (level <= 1) level = 2;
            if (level > 6) level = 6;

            const cssClass = classMap[level] || '';

            return `<h${level} class="${cssClass}">${text}</h${level}>`;
        },

        image() {
            return ''; // Block all images
        },

        link({href, title, text}) {
            const titleAttr = title ? `title="${title}"` : '';

            return `<a href="${href}" ${titleAttr} class="kui-util-link-1">${text}</a>`;
        }
    }
});

export {createConfig};
